"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Occ_Title3 = exports.Occ_Title2 = exports.Occ_Title1 = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var base = (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    font-family: var(--font-family-secondary);\n    text-decoration: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: var(--line-height-tight);\n    color: ", ";\n    text-align: ", ";\n"])), function (props) {
  return props.underline ? 'underline' : 'none';
}, function (props) {
  if (props.size === 'xxs') {
    return 'var(--font-size-xxs)';
  } else if (props.size === 'xs') {
    return 'var(--font-size-xs)';
  } else if (props.size === 'sm') {
    return 'var(--font-size-sm)';
  } else if (props.size === 'md') {
    return 'var(--font-size-md)';
  } else if (props.size === 'lg') {
    return 'var(--font-size-lg)';
  } else if (props.size === 'xl') {
    return 'var(--font-size-xl)';
  } else if (props.size === 'xxl') {
    return 'var(--font-size-xxl)';
  } else if (props.size === 'xxxl') {
    return 'var(--font-size-xxxl)';
  } else if (props.size === 'xxxxl') {
    return 'var(--font-size-xxxxl)';
  } else if (props.hierarchy === '1') {
    return 'var(--font-size-lg)';
  } else if (props.hierarchy === '2') {
    return 'var(--font-size-md)';
  } else if (props.hierarchy === '3') {
    return 'var(--font-size-xs)';
  } else {
    return 'var(--font-size-base)';
  }
}, function (props) {
  if (props.weight === 'hairline') {
    return 'var(--font-weight-hairline)';
  } else if (props.weight === 'thin') {
    return 'var(--font-weight-thin)';
  } else if (props.weight === 'light') {
    return 'var(--font-weight-light)';
  } else if (props.weight === 'normal') {
    return 'var(--font-weight-normal)';
  } else if (props.weight === 'middle') {
    return 'var(--font-weight-middle)';
  } else if (props.weight === 'semibold') {
    return 'var(--font-weight-semibold)';
  } else if (props.weight === 'bold') {
    return 'var(--font-weight-bold)';
  } else if (props.weight === 'extrabold') {
    return 'var(--font-weight-extrabold)';
  } else if (props.weight === 'black') {
    return 'var(--font-weight-black)';
  } else {
    return 'var(--font-weight-extrabold)';
  }
}, function (props) {
  if (props.color === 'primary') {
    return 'var(--color-primary)';
  } else if (props.color === 'secondary') {
    return 'var(--color-secondary)';
  } else if (props.color === 'default') {
    return 'var(--color-base-black)';
  } else if (props.color === 'white') {
    return 'var(--color-base-white)';
  } else if (props.color === 'muted') {
    return 'var(--color-font-muted)';
  } else if (props.color === 'error') {
    return 'var(--color-red-600)';
  }
}, function (props) {
  if (props.align === 'left') {
    return 'left';
  } else if (props.align === 'right') {
    return 'right';
  } else if (props.align === 'center') {
    return 'center';
  } else if (props.align === 'initial') {
    return 'initial';
  } else if (props.align === 'inherit') {
    return 'inherit';
  }
});
var Occ_Title1 = (0, _styledComponents["default"])('h1')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", "\n"])), base);
exports.Occ_Title1 = Occ_Title1;
var Occ_Title2 = (0, _styledComponents["default"])('h2')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", "\n"])), base);
exports.Occ_Title2 = Occ_Title2;
var Occ_Title3 = (0, _styledComponents["default"])('h3')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    ", "\n"])), base);
exports.Occ_Title3 = Occ_Title3;